import i18next from 'i18next';
import common from '../common';

export default class Text extends PIXI.Text {
	constructor(key, params) {
		let options = {};

		options = Object.assign(options, params);

		const size = (parseInt(params.font.slice(0, params.font.indexOf('px'))) - 6);

		options.fontFamily = [...common.fonts, 'NotoSans-Regular', 'sans-serif'];
		options.fontSize = `${size}px`; // take 6 from size because there's some size discrepancies where BitmapTexts look smaller than PIXI.Text
		options.fill = !params.tint || params.tint === 0 ? '#000000' : `#${params.tint.toString(16)}`;

		options.lineHeight = params.lineHeight || size * 1.2;
		options.letterSpacing = params.letterSpacing || size * 0.012;

		if (params.wordWrap) {
			options.wordWrap = params.wordWrap;
			options.wordWrapWidth = params.wordWrapWidth || 100;
		}

		if (params.maxWidth) {
			options.wordWrap = true;
			options.wordWrapWidth = params.maxWidth;
		}

		// break words on script languages
		options.breakWords = common.config.language.startsWith('zh');

		// texts may be used for other things than i18n, so we need to check if the key exists
		let text = key;

		if (i18next.exists(key)) {
			text = i18next.t(key, key);
		}

		super(text, options);

		this._key = key;
		this._autoResize = params.autoResize || false;
		this._maxWidth = params.maxWidth || 0;
		this.resolution = common.retina === '1x' ? 2 : 1;
		this.signals = {
			languageChange: new P3.utils.MiniSignal(),
		};

		// this._languageChangeSignal = common.languageManager.signals.changed.add(this.onLanguageChange, this);
	}

	destroy() {
		// common.languageManager.signals.changed.detach(this._languageChangeSignal, this);
		this.signals.languageChange.detachAll();
		super.destroy();
	}

	onLanguageChange() {
		this.text = this._key;
		this.signals.languageChange.dispatch();
	}

	set text(v) {
		if (v && v.length > 0 && i18next.exists(v)) {
			this._key = v;
			v = i18next.t(v);
		}

		if (this.style) {
			this.style.fontFamily = [...common.fonts, 'sans-serif'];
			this.style.breakWords = common.config.language.startsWith('zh');
		} else {
			this.style = { fontFamily: [...common.fonts, 'sans-serif'], breakWords: common.config.language.startsWith('zh') };
		}

		if (this._autoResize && this._maxWidth > 0 && this.width > this._maxWidth) {
			while (this.width > this._maxWidth) {
				this.style.fontSize = `${parseInt(this.style.fontSize) - 1}px`;
			}
		}

		super.text = v;
	}

	get text() {
		return super.text;
	}

	get key() {
		return this._key;
	}

	set key(v) {
		this._key = v;
	}
}
